export function isShareLinkAuthorizationPending(authorization, search = window.location.search) {
    const params = new URLSearchParams(search)
    const share = params.get("share")

    if (!share || share === "clear") return false

    if (authorization === null || authorization === undefined) return true
    if (!Array.isArray(authorization)) return false
    return !authorization.some(Boolean)
}
